var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":_vm.mapId}},[(_vm.error)?_c('div',{staticClass:"error-box"},[_vm._v(_vm._s(_vm.error))]):_vm._e(),(_vm.showSlot && !_vm.error)?_vm._t("default",null,{"map":_vm.map}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }